import { render, staticRenderFns } from "./InviteUser.vue?vue&type=template&id=27475d44&scoped=true"
import script from "./InviteUser.vue?vue&type=script&lang=js"
export * from "./InviteUser.vue?vue&type=script&lang=js"
import style0 from "./InviteUser.vue?vue&type=style&index=0&id=27475d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27475d44",
  null
  
)

export default component.exports